import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { decodeJWT } from './utils';

// Define the props that Teammembers (or any child component) expects
interface ChildProps {
  checked?: boolean;
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ProtectedRouteProps {
  children: React.ReactElement<ChildProps>; // Specify that children accepts ChildProps
  allowedRoles: string[];
  checked?: boolean;
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
  checked,
  setChecked,
}) => {
  console.log(allowedRoles, 'allowedRolesssssssssssss');
  const verifyAccessString = Cookies.get('loginToken');

  if (!verifyAccessString) {
    return <Navigate to="/login" replace />;
  }

  const decodedToken = decodeJWT(verifyAccessString);
  console.log(decodedToken, 'decodedTokendecodedTokendecodedToken');
  const userRole = decodedToken?.user_role_name;

  console.log(userRole, 'userRoleuserRoleuserRole', allowedRoles, 'allowedRolesallowedRoles');

  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  return allowedRoles.includes(userRole) ? (
    React.isValidElement(children) ? (
      React.cloneElement(children, { checked, setChecked })
    ) : (
      <>{children}</>
    )
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default ProtectedRoute;